export enum InterpretationExportMode {
    OnlySeismic = 1, //só daquela interpretação
    OnlySurvey = 2, //todos daquele survey
    All = 3, //todas daquela interpretação
}